'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (from, to) {
  if (from) {
    ['hour', 'minute', 'second', 'millisecond'].forEach(function (part) {
      to.set(part, from.get ? from.get(part) : from[part]);
    });
  }

  return to;
};


//////////////////
// WEBPACK FOOTER
// ./~/react-date-picker/lib/utils/forwardTime.js
// module id = 604
// module chunks = 0